__webpack_require__.p = "https://webid.cdn.garenanow.com/assets/pathofhero.codm.garena.com/";